import {
	getCleanUrl,
	getDynamicAreaIdWithoutContextFromUrl,
	getElementIdWithContext,
} from 'fg-frontend/src/partialUpdate/partialUpdateUtils';
import $ from 'jquery';
import { getNextUniqueId } from 'fg-frontend/src/lib/idGenerator';
import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';
import { executeWebAction } from 'fg-frontend/src/webComponents/connectWebActions';
import { decorateInnerElements, disposeInnerComponents } from 'fg-frontend/src/webComponents/decorate';
/**
 *  <div
 *  	data-esp-trigger-event		= hover | click
 *  	data-esp-class-name			= string = třída, která bude přenesena na ajaxem nahraný popup (jak na fixed, tak na floating)
 *  	data-esp-content-type		= html (předgenerovaný div v HTML)
 *  								= ajax (url načítaného obsahu ajaxem - poprvé, poté cache)
 *  								= ajaxScript (url ajaxem načítaného obsahu - provádí se vždy - vhodné pro formuláře, kde se očekává zpracování javascriptu + různé hodnoty CSRF tokenů)
 *  							    = iframe
 *  	data-esp-type 				= floating | fixed = zatím pouze pro content-type = ajax | ajaxScript, u zobrazování vygenerovaného HTML nepředpokládáme přesun na jiné místo, okno respektuje nastavení ze stylů
 *  	data-esp-target				= v případě content-type = html - jde o selector, který bude odkryt / zakryt
 *  								= v případě content-type = ajax - jde o URL, ze které budou načtena data a response bude vykreslena v cílové html vrstvě
 *  								= v případě content-type = ajaxScript - jde o URL, ze které budou načtena data a response bude vykreslena v cílové html vrstvě s tím, že budou nahrány a zpracovány i javascripty
 *  							    = v případě content-type = iframe - jde o URL, které bude načteno do iframe
 *  />
 */

var DEFAULTS = {
	fixedPopupContainer: '<div class="esp-fixed-container"></div>',
	fixedPopup: (customClass) => '<div class="esp-target esp-target-opened esp-fixed-target' + (customClass && customClass != '' ? ' ' + customClass : '') + '"></div>',
	floatingPopup: (customClass) => '<div class="esp-target esp-floating-target' + (customClass && customClass != '' ? ' ' + customClass : '') + '"></div>',
	activeTriggerClass: 'esp-trigger-active',
	customCloseClass: 'js_esp-custom-close',
  allowContainerClickClose: false
};

var DEFAULTS_CONFIRM = {
	confirmClassName: '',
	messages: {
		title: 'Potvrzení',
		text: '',
		confirmButton: 'Ano',
		declineButton: 'Ne'
	},
	data: {},
	trigger: null,
	action: null,     // function(response, data, trigger) {}
	internalClassNames: {
		TITLE: 'esp-confirm__title',
		TEXT: 'esp-confirm__text',
		BTN_C: 'esp-confirm__btn-container',
		CONFIRM: 'esp-confirm__btn esp-confirm__confirm-btn',
		DECLINE: 'esp-confirm__btn esp-confirm__decline-btn'
	}
};

/***
 * Popup handler
 * @param options
 * @constructor
 */
var EdeeshopPopup = function (options) {
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._initialise();
};

/**
 * Init method, starts rendering HTML and binds events
 * @private
 */
EdeeshopPopup.prototype._initialise = function(){

	this.floatingPopupCloseTimeout = null;
	this.openedHtmlPopup = null;


	/**
	 * příprava kontejneru, do kterého budou nahrávány fixed (fullscreen) popup okna
	 */
	this._renderFixedContainer();

	/**
	 * bind eventů mouseenter a click (+ mouse leave)
	 */
	this._bindEvents();
};

EdeeshopPopup.prototype._renderFixedContainer = function() {
	this.fixedContainer = $(this.options.fixedPopupContainer).appendTo($('body'));
	this._handleFixedPopupCustomCloseButton();
};

EdeeshopPopup.prototype._handleFixedPopupCustomCloseButton = function() {
	var _self = this;
	$(this.fixedContainer).on('click.esp__custom-close', `.${this.options.customCloseClass}`, function(event) {
		event.preventDefault();
		_self._closeFixedPopup();
	});
};

/**
 * nabinduje na vhodné odkazy (cokoliv) eventy
 * 	- mouseenter - otevření popup okna
 * 	- mouseleave - spuštení timeoutu pro zavření popup okna
 * 	- click - otevření popup okna
 * @private
 */
EdeeshopPopup.prototype._bindEvents = function() {
	var _self = this;

	$('body')
	/**
	 * bind těch odkazů, které mají data-esp-trigger-event === hover
	 */
		.on('mouseenter.esp', '.js_esp-trigger[data-esp-trigger-event="hover"]', function(event) {
			var settings = _self._getPopupSettingsData($(event.currentTarget));

			if (settings.contentType == 'html' && settings.targetLayer) {
				// nejprve odstraň jakýkoliv otevřený floating popup
				_self._removeFloatingPopup();
			}

			if (settings.contentType == 'ajax' || settings.contentType == 'ajaxScript') {
				// nejprve odstraň jakýkoliv otevřený html div
				_self._hideHtmlPopup();
			}

			_self._handleEnterEvent(event.currentTarget, 'hover');

		})
		.on('mouseleave.esp', '.js_esp-trigger[data-esp-trigger-event="hover"]', function(event) {
			var settings = _self._getPopupSettingsData($(event.currentTarget));

			_self.floatingPopupCloseTimeout = setTimeout(function() {
				if (settings.contentType == 'html' && settings.targetLayer) {
					_self._hideHtmlPopup();
				}

				if (settings.contentType == 'ajax' || settings.contentType == 'ajaxScript') {
					_self._removeFloatingPopup();
				}
			}, 200);

		})
		/**
		 * bind těch odkazů, které mají data-esp-trigger-event === click
		 */
		.on('click.esp', '.js_esp-trigger[data-esp-trigger-event="click"]', function(event) {
			event.preventDefault();
			_self._handleEnterEvent(event.currentTarget, 'click');
		});

	// zavření popup okna na ESC
	$(document).off('keyup.esp').on('keyup.esp', function (event){
		if (_self.fixedPopupCloseButton instanceof $ && event.which == 27) {
			if (!window.activeZoom) {
				_self._fixedPopupCloseButtonHandler();
			}
		}
	});

	// zavření popup okna kliknutím na kontejner
  _self.fixedContainer.on('click', function (e) {
    if (_self.options.allowContainerClickClose) {
      if (e.target !== this)
        return;

      if (_self.fixedPopupCloseButton instanceof $) {
        _self._closeFixedPopup();
      }
    }
  });
};

/**
 * zpracování samotné akce pro otevření popup okna
 * @param trigger - odkaz / div / cokoliv, co spouští otevření popup okna
 * @param eventType - typ eventu - hover / click
 * @private
 */
EdeeshopPopup.prototype._handleEnterEvent = function(trigger, eventType) {
	var $trigger = $(trigger);
	this.$trigger = $trigger;
	var settings = this._getPopupSettingsData($trigger);
	var _self = this;

  // povolit zavřít klikem mimo kontejner ve speciálním případě
  this.options.allowContainerClickClose = (settings.className && settings.className === 'esp-language-info' ? true : false);

	// clear timeoutu v případě, že najedeme na trigger v době, kdy už běží zavření okna (aby se nezavřelo hned po novém otevření)
	clearTimeout(this.floatingPopupCloseTimeout);

	/**
	 * otevření a zavření předem vyrenderované vrstvy
	 */
	if (settings.contentType == 'html' && settings.targetLayer) {

		// ukázat vrstvu
		$(settings.targetLayer).addClass('esp__target--opened');
		// deprecated
		$(settings.targetLayer).addClass('esp-target-opened');
		this.openedHtmlPopup = $(settings.targetLayer);
		this._setActiveTriggerUnique($trigger);

		if (eventType === 'hover') {
			$(settings.targetLayer)
			// na mouseover zrušit zavření z mouseleave triggeru
				.on('mouseenter.esp', function() {
					clearTimeout(_self.floatingPopupCloseTimeout);
				})

				// a na mouseleave ji teprve zrušit
				.on('mouseleave.esp', function() {
					_self.floatingPopupCloseTimeout = setTimeout(function() {
						_self._hideHtmlPopup();
					}, 200);
				});
		}
	}

	/**
	 * nahrávání ajaxu pomocí jQuery.load kvůli zpracování javascriptu
	 */
	if (settings.contentType == 'ajaxScript' && settings.dataUrl) {

		if (settings.type == 'fixed') {
			this._renderFixedPopupAndLoadDynamicData(settings.dataUrl, settings.className);
		} else if (settings.type == 'floating') {
			this._renderFloatingPopupAndLoadDynamicData(settings.dataUrl, $trigger, settings.className, eventType);
		}
	}

	/**
	 * nahravání ajaxu klasickým GETem
	 * kešování obsahu do data-esp-html-content atributu
	 * při znovuvyvolání použít nakešovaná data
	 */
	if (settings.contentType == 'ajax' && settings.dataUrl) {

		// data z ajaxu nejsou zatím naloadována
		if ($trigger.data('espLoaded') !== '1') {

			$.ajax({
				url: settings.dataUrl,
				cache: false,
				method: 'GET'
			}).done(function( data ) {
				// uložení už jednou načtených dat
				$trigger.data('espHtmlContent', data).data('espLoaded', '1');

				if (settings.type === 'fixed') {
					// vytvoření popup okna
					_self._renderFixedPopupWithData(data, settings.className);

				} else if (settings.type == 'floating') {
					_self._renderFloatingPopupWithData(data, $trigger, settings.className, eventType);
				}
			});
		}
		// a tady už jsou, stačí je použít
		else {

			if (settings.type === 'fixed') {
				// vytvoření popup okna
				_self._renderFixedPopupWithData($trigger.data('espHtmlContent'), settings.className);

			} else if (settings.type == 'floating') {
				_self._renderFloatingPopupWithData($trigger.data('espHtmlContent'), $trigger, settings.className, eventType);
			}
		}

	}

	if (settings.contentType == 'iframe' && settings.dataUrl) {
		if (settings.type === 'fixed') {
			// vytvoření popup okna
			_self._renderFixedPopupWithIframe(settings.dataUrl, settings.className);

		} else if (settings.type == 'floating') {
			_self._renderFloatingPopupWithIframe(settings.dataUrl, $trigger, settings.className, eventType);
		}
	}
};


/**
 * přečte data z dodaného triggeru
 * @private
 */
EdeeshopPopup.prototype._getPopupSettingsData = function($trigger) {
	var triggerSettings = {};
	triggerSettings['contentType'] = $trigger.data('espContentType');
	triggerSettings['className'] = $trigger.data('espClassName') || '';

	if (triggerSettings['contentType'] === 'html') {
		triggerSettings['targetLayer'] = $trigger.data('espTarget');
	}
	if (triggerSettings['contentType'] === 'ajax' || triggerSettings['contentType'] === 'ajaxScript') {
		triggerSettings['dataUrl'] = $trigger.data('espTarget');
		triggerSettings['type'] = $trigger.data('espType') || 'fixed';
		triggerSettings['ajaxCache'] = $trigger.data('contentType') === 'ajax';
	}

	if (triggerSettings['contentType'] === 'iframe') {
		triggerSettings['dataUrl'] = $trigger.data('espTarget');
		triggerSettings['type'] = $trigger.data('espType') || 'fixed';
	}

	return triggerSettings;
};

/**
 * samotné vytvoření fixed popup okna, bez obsahu
 * @param customClass
 * @param ignoreCloseButton
 * @private
 */
EdeeshopPopup.prototype._prepareFixedPopup = function(customClass, ignoreCloseButton) {
	var _self = this;

	// vytvoř samotný popup v rámci fixed dimmingu
	this.fixedPopup = $(this.options.fixedPopup(customClass)).appendTo(this.fixedContainer);

	if (!ignoreCloseButton) {
		this._renderFixedPopupCloseButton();
	}

	this.fixedContainer.show();
	this._makeBodyUnscrollable();

};

EdeeshopPopup.prototype._renderFixedPopupCloseButton = function() {
	var _self = this;

	// vytvoř tlačítko na zavření popupu
	this.fixedPopupCloseButton = $('<div class="esp__fixed-close esp-fixed-close"></div>').appendTo(this.fixedPopup);

	// proveď zavření popup okna
	this.fixedPopupCloseButton.on('click', function() {
		_self._fixedPopupCloseButtonHandler();
	});
};

EdeeshopPopup.prototype._fixedPopupCloseButtonHandler = function() {
	var _self = this;

	_self.fixedPopupCloseButton.off();
	_self._closeFixedPopup();
};

EdeeshopPopup.prototype._closeFixedPopup = function() {
	var _self = this;

	_self.fixedContainer.empty().hide();
	_self._makeBodyScrollable();
};


/**
 * metoda vytvoří fixed popup okno a nahraje do něj dodaný obsah
 * @param result
 * @param customClass
 * @param ignoreCloseButton
 * @private
 */
EdeeshopPopup.prototype._renderFixedPopupWithData = function(result, customClass, ignoreCloseButton) {

	// vytvoř prázdné okno
	this._prepareFixedPopup(customClass, ignoreCloseButton);

	// přidej obsah
	$(result).appendTo(this.fixedPopup);
	decorateInnerElements(this.fixedPopup[0]);
};

/**
 *
 * @private
 */
EdeeshopPopup.prototype._renderFixedPopupAndLoadDynamicData = function(dataUrl, customClass) {
	var _self = this,
	    dataUrlTimestamp = _self._addTimestampToUrl(dataUrl);

	// vytvoř prázdné okno
	this._prepareFixedPopup(customClass);

	// load content
	this.fixedPopup.addClass('esp__target--loading');
	// deprecated
	this.fixedPopup.addClass('esp-popup-loading');

	if (dataUrl.indexOf('#') === -1) {

		this.fixedPopup[0].addEventListener('partialUpdateComplete', (e) => {
			const {
				detail: {
					settings: {
						type,
					},
					hasError,
				},
			} = e;
			if (type === 'POST' && !hasError) {
				const props = _self.$trigger.data();
				const {
					      successAction,
					      successActionPayload,
				      } = props;
				if (successAction) {
					executeWebAction(successAction, successActionPayload);
				}
			}
		});
		const layoutCotext = getNextUniqueId();
		let target = getDynamicAreaIdWithoutContextFromUrl(dataUrl);

		target = getElementIdWithContext(target, layoutCotext);

		const url = getCleanUrl(dataUrl);
		const element = $(`<div id="${target}"></div>`);
		this.fixedPopup.append(element);
		execute({
			target,
			url,
			alterHistory: false,
			onAfterContentsReplace: () => {
				this._renderFixedPopupCloseButton();
				this.fixedPopup.removeClass('esp__target--loading');
				//deprecated
				this.fixedPopup.removeClass('esp-popup-loading');
			},
		});
	}
	else {
		this.fixedPopup.load(dataUrlTimestamp, function () {
			_self._renderFixedPopupCloseButton();
			_self.fixedPopup.removeClass('esp__target--loading');
			//deprecated
			_self.fixedPopup.removeClass('esp-popup-loading');
		});
	}
};


EdeeshopPopup.prototype._addTimestampToUrl = function(dataUrl) {
	var _self = this,
	    dataUrlArray,
	    dataUrlResult = dataUrl,
	    dataUrlHash = '';

	if (dataUrl.indexOf('#') > -1) {
		dataUrlArray = dataUrl.split('#');
		dataUrlResult = dataUrlArray[0];
		dataUrlHash = ' #' + dataUrlArray[1];
	}

	dataUrlResult += (dataUrlResult.indexOf('?') > -1) ? '&_ts=' : '?_ts=';
	dataUrlResult += this._getTimestamp();
	dataUrlResult += dataUrlHash;

	return dataUrlResult;
};

EdeeshopPopup.prototype._renderFloatingPopupCloseButton = function() {

	var _self = this;

	// vytvoř tlačítko na zavření popupu
	this.floatingPopupCloseButton = $('<div class="esp__fixed-close esp-fixed-close"></div>').appendTo(this.floatingPopup);

	// proveď zavření popup okna
	this.floatingPopupCloseButton.on('click', function() {
		_self._removeFloatingPopup();
	});
};

EdeeshopPopup.prototype._handleFloatingPopupCustomCloseButton = function() {

	var _self = this;

	//custom tlačítko na zavření okna
	$(`.${this.options.customCloseClass}`, this.floatingPopup).on('click', function(event) {
		event.preventDefault();
		if (_self.floatingPopup instanceof $) {
			_self.floatingPopup.off().remove();
			_self._setAllTriggersInactive();
		}
	});
};

EdeeshopPopup.prototype._removeFloatingPopup = function() {
	if (this.floatingPopupCloseButton instanceof $) {
		this.floatingPopupCloseButton.off();
	}

	if (this.floatingPopup instanceof $) {
		this.floatingPopup.off().remove();
		this._setAllTriggersInactive();
	}
};

EdeeshopPopup.prototype._hideHtmlPopup = function() {
	if (this.openedHtmlPopup instanceof $) {
		this.openedHtmlPopup.off('mouseenter.esp mouseleave.esp').removeClass('esp__target--opened').removeClass('esp-target-opened');
		this.openedHtmlPopup = null;
		this._setAllTriggersInactive();
	}
};

EdeeshopPopup.prototype._setActiveTriggerUnique = function(trigger) {
	this._setAllTriggersInactive();
	$(trigger).addClass(this.options.activeTriggerClass);
	// deprecated
	$(trigger).addClass('esp-trigger-active');
};

EdeeshopPopup.prototype._setAllTriggersInactive = function() {
	$('.'+this.options.activeTriggerClass).removeClass(this.options.activeTriggerClass);
	// deprecated
	$('.'+this.options.activeTriggerClass).removeClass('esp-trigger-active');
};


/**
 *
 * @param dataUrl
 * @param trigger
 * @param customClass
 * @param eventType
 * @private
 */
EdeeshopPopup.prototype._renderFloatingPopupAndLoadDynamicData = function(dataUrl, trigger, customClass, eventType) {
	var _self = this,
	    dataUrlTimestamp = _self._addTimestampToUrl(dataUrl);

	this._renderFloatingPopup(trigger, customClass, eventType);

	// load content
	this.floatingPopup.addClass('esp__target--loading');
	// deprecated
	this.floatingPopup.addClass('esp-popup-loading');
	this.floatingPopup.load(dataUrlTimestamp, function() {
		_self.floatingPopup.addClass('esp__target--opened');
		_self.floatingPopup.removeClass('esp__target--loading');

		// deprecated
		_self.floatingPopup.addClass('esp-target-opened');
		_self.floatingPopup.removeClass('esp-popup-loading');

		if (eventType === 'click') {
			_self._renderFloatingPopupCloseButton();
			_self._handleFloatingPopupCustomCloseButton();
		}

		_self._setActiveTriggerUnique(trigger);
	});
};

EdeeshopPopup.prototype._renderFloatingPopupWithData = function(result, trigger, customClass, eventType) {
	this._renderFloatingPopup(trigger, customClass, eventType);
	this.floatingPopup.addClass('esp__target--opened');
	// deprecated
	this.floatingPopup.addClass('esp-target-opened');

	if (eventType === 'click') {
		this._renderFloatingPopupCloseButton();
		this._handleFloatingPopupCustomCloseButton();
	}

	// přidej obsah
	$(result).appendTo(this.floatingPopup);

	this._setActiveTriggerUnique(trigger);

};

/**
 *
 * @param trigger
 * @param customClass
 * @param eventType
 * @private
 */
EdeeshopPopup.prototype._renderFloatingPopup = function(trigger, customClass, eventType) {
	var _self = this;

	if (this.floatingPopupCloseButton instanceof $) {
		this.floatingPopupCloseButton.off().remove();
	}

	if (this.floatingPopup instanceof $) {
		this.floatingPopup.remove();
	}

	// vytvoř floatovaný popup
	this.floatingPopup = $(this.options.floatingPopup(customClass));
	trigger.after(this.floatingPopup);

	// bind close event
	if (eventType === 'hover') {
		this.floatingPopup
			.on('mouseenter.esp', function() {
				clearTimeout(_self.floatingPopupCloseTimeout);
			})

			// a na mouseleave ji teprve zrušit
			.on('mouseleave.esp', function() {
				_self.floatingPopupCloseTimeout = setTimeout(function() {
					_self._removeFloatingPopup();
				}, 200);
			});
	}
};


/**
 * metoda vytvoří fixed popup okno a nahraje do něj dodaný iframe
 * @param url
 * @param customClass
 * @private
 */
EdeeshopPopup.prototype._renderFixedPopupWithIframe = function(url, customClass) {

	// vytvoř prázdné okno
	this._prepareFixedPopup(`esp__target--iframe esp-iframe ${customClass}`);

	var $iframe = this._createIframe(url);
	$iframe.appendTo(this.fixedPopup);
};


EdeeshopPopup.prototype._renderFloatingPopupWithIframe = function(url, trigger, customClass, eventType) {
	this._renderFloatingPopup(trigger, customClass, eventType);
	this.floatingPopup.addClass('esp__target--iframe').addClass('esp__target--opened ');
	// deprecated
	this.floatingPopup.addClass('esp-iframe').addClass('esp-target-opened ');

	if (eventType === 'click') {
		this._renderFloatingPopupCloseButton();
		this._handleFloatingPopupCustomCloseButton();
	}

	var $iframe = this._createIframe(url);
	$iframe.appendTo(this.floatingPopup);

	this._setActiveTriggerUnique(trigger);

};

/**
 * create Iframe element
 * @private
 */
EdeeshopPopup.prototype._createIframe = function(url) {
	return $(`<iframe src="${url}" height="100%" width="100%"></iframe>`);
};

/**
 *
 * @private
 */
EdeeshopPopup.prototype._getTimestamp = function() {
	return new Date().getTime();
};


/**
 *
 * @private
 */
EdeeshopPopup.prototype._makeBodyUnscrollable = function() {
	var getScrollbarWidth = () => {
		var div = $('<div style="width:50px;height:50px;overflow:hidden;position:absolute;top:-200px;left:-200px;"><div style="height:100px;"></div>');
		$('body').append(div);
		var w1 = $('div', div).innerWidth();
		div.css('overflow-y', 'scroll');
		var w2 = $('div', div).innerWidth();
		$(div).remove();
		return (w1 - w2);
	};

	$('body').addClass('overflow-full').css( { 'margin-right': getScrollbarWidth() + 'px' } );

};

EdeeshopPopup.prototype._makeBodyScrollable = function() {
	$('body').removeClass('overflow-full').css( { 'margin-right': '0px' } );
};

/**
 * confirm popup
 */

EdeeshopPopup.prototype._buildTexts = function(messages, classNames) {
	var result = `<h2 class="${classNames.TITLE}">${messages.title}</h2>`;
	result += `<div class="${classNames.TEXT}">${messages.text}</div>`;
	result += `<p class="${classNames.BTN_C}"></p>`;
	return result;
};

EdeeshopPopup.prototype._addButtonsToConfirm = function(messages, classNames) {
	var $buttonContainer = $(`.${classNames.BTN_C}`, this.fixedPopup);
	var $confirmButton = this.$confirmButton =  $(`<a href="javascript:" class="${classNames.CONFIRM}">${messages.confirmButton}</a>`);
	var $declineButton =  this.$declineButton = $(`<a href="javascript:" class="${classNames.DECLINE}">${messages.declineButton}</a>`);
	$buttonContainer.append($confirmButton).append($declineButton);
};

EdeeshopPopup.prototype._bindConfirmButtons = function(opts) {
	var _self = this;

	if (this.$confirmButton instanceof $ && this.$declineButton instanceof $) {

		// confirm
		this.$confirmButton.on('click', function(e) {
			e.preventDefault();
			var confirmHref = $(opts.trigger).attr('href');
			var confirmTarget = $(opts.trigger).attr('target');

			//execute confirm action
			if (opts.action && $.isFunction(opts.action)) {
				opts.action.call(_self, 'confirm', opts.data, opts.trigger);
			}
			// execute simple redirect
			else if (confirmHref) {
				if (confirmTarget) {
					window.open(confirmHref, confirmTarget);
				} else {
					window.location.href = confirmHref;
				}
			}

			_self._destroyConfirm();
		});

		// decline
		this.$declineButton.on('click', function(e) {
			e.preventDefault();
			_self._declineButtonHandler(opts);
		});

		// zavření popup okna na ESC
		$(document).off('keyup.espConfirm').on('keyup.espConfirm', function (event){
			if (_self.$declineButton instanceof $ && event.which == 27) {
				_self._declineButtonHandler(opts);
			}
		});
	}
};

EdeeshopPopup.prototype._declineButtonHandler = function(opts) {
	var _self = this;

	if (opts.action && $.isFunction(opts.action)) {
		opts.action.call(_self, 'decline', opts.data, opts.trigger);
	}
	_self._destroyConfirm();
};


EdeeshopPopup.prototype._destroyConfirm = function() {
	this.$confirmButton.off();
	this.$declineButton.off();

	this._closeFixedPopup();
};

EdeeshopPopup.prototype.close = function() {
	this._closeFixedPopup();
};


/************************
 * public metody
 */

/**
 *  public metoda, která může být zavolána externě a vykreslí popup s výsledkem
 */
EdeeshopPopup.prototype.createPopup = function(data, customClass) {
	this._renderFixedPopupWithData(data, customClass);
};

/**
 * public metoda, která vykreslí popup s confirmem. Očekává na vstupu data k confirmu - viz @DEFAULTS_CONFIRM
 * @param params
 */
EdeeshopPopup.prototype.createConfirm = function(params) {
	var confirmOptions = $.extend(true, {}, DEFAULTS_CONFIRM, params);

	this._renderFixedPopupWithData(this._buildTexts(confirmOptions.messages, confirmOptions.internalClassNames), `esp__target--confirm esp-confirm ${confirmOptions.confirmClassName}`, true);
	this._addButtonsToConfirm(confirmOptions.messages, confirmOptions.internalClassNames);
	this._bindConfirmButtons(confirmOptions);
};

module.exports = EdeeshopPopup;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/EdeeshopPopup.js